import React from 'react';

const Footer = () => {
  return (
    <div className="print-footer"></div>
  );
};

export default Footer;